import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import navbar_fondo_rojo from '../../global/imagenes/navbar_fondo_rojo.png';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#C9030E',
    backgroundImage: `url(${navbar_fondo_rojo})`,
    backgroundSize: 'cover',
    backgroundPosition: 'right center',
    backgroundRepeat: 'no-repeat',
    color: '#ffffff',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: '#ffffff',
    fontWeight: 700,
  },
  closeButton: {
    color: '#ffffff',
  },
  actionButton: {
    color: '#ffffff',
    fontWeight: 700,
  }
}));

const CrearAccion = (titulo_accion, accion, classes) => {
  const resp = accion ? <Button className={classes.actionButton} onClick={accion.bind(this, false)}> {titulo_accion} </Button> : '';
  return resp;
}

export default function AppBarModal({ titulo, mostrarModal, titulo_accion = "Cerrar", accion, close_switch = true }) {
  const classes = useStyles();
  return (
    <AppBar className={classes.appBar} elevation={0}>
      <Toolbar>
        {close_switch &&
          <IconButton edge="start" className={classes.closeButton} onClick={mostrarModal.bind(this, false)} aria-label="close">
            <Icon>close</Icon>
          </IconButton>
        }
        <Typography variant="h6" className={classes.title}>
          {titulo}
        </Typography>
        {CrearAccion(titulo_accion, accion, classes)}
      </Toolbar>
    </AppBar>
  );
}


AppBarModal.propTypes = {
  //funciones
  titulo: PropTypes.string.isRequired,
  mostrarModal: PropTypes.func.isRequired,
  titulo_accion: PropTypes.string.isRequired,
  accion: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
}
